import React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

import './MarketTitle.scss';

interface Props {
    name: string;
    defaultMsg: MessageDescriptor;
}

const MarketTitle: React.FC<Props> = ({ name, defaultMsg }) => {
    return name ? (
        renderName(name)
    ) : (
        <FormattedMessage {...defaultMsg}>
            {(txt: string) => renderName(txt)}
        </FormattedMessage>
    );
};

export default MarketTitle;

function renderName(name: string) {
    // TODO: remove hardcode 1x2
    const isOneXTwo = name.toLocaleLowerCase() === '1x2';

    return (
        <div styleName="name" className="__app-MarketTitle-name" title={name}>
            {isOneXTwo ? (
                name.split('').map(letter => <div key={letter}>{letter}</div>)
            ) : (
                <div styleName="ellipsis">{name}</div>
            )}
        </div>
    );
}
